import {Line} from "@/app/[locale]/common/components/Line/Line";
import s from "@/app/[locale]/common/components/Footer/Footer.module.scss";
import {Link} from '@/i18n/routing';
import {TFooterColumnProps} from "@/app/[locale]/common/components/Footer/types";

export const FooterColumn = ({ data }: TFooterColumnProps) => {
    return (
        <div>
            <Line className={s.footer_content_column_line}/>
            <ul className={s.footer_content_column}>
                {
                    data.map((item, index: number) => (
                        <li key={index}><Link href={item.href}>{item.title}</Link></li>
                    ))
                }
            </ul>
        </div>
    );
};